import { render } from "./wokerDetail2.vue?vue&type=template&id=a102e5d8&scoped=true"
import script from "./wokerDetail2.vue?vue&type=script&lang=js"
export * from "./wokerDetail2.vue?vue&type=script&lang=js"

import "./wokerDetail2.vue?vue&type=style&index=0&id=a102e5d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a102e5d8"]])

export default __exports__